<div class="confirm-dialog-container">
  <!-- Modal Header -->
  <div class="modal-header">
    <h2 class="modal-title">{{ data.title }}</h2>
    <button 
      mat-icon-button 
      class="close-button" 
      (click)="onCancel()"
      aria-label="Close"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Modal Content -->
  <div class="modal-content">
    <p class="dialog-message">{{ data.message }}</p>
  </div>

  <!-- Modal Actions -->
  <div class="modal-actions">
    <button 
      class="cancel-button"
      (click)="onCancel()"
    >
      {{ data.cancelButtonText || 'Cancel' }}
    </button>
    <button 
      class="confirm-button"
      [class.destructive]="data.isDestructive"
      (click)="onConfirm()"
    >
      {{ data.confirmButtonText || 'Confirm' }}
    </button>
  </div>
</div>
